var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","rounded":"lg"}},[_c('v-card-title',[_vm._v("Documentação")]),_c('v-card-text',[_c('envio-documentacao')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }